<template>
    <form class="form-calification">
        <p class="calification" @mouseout="resetStartsSelected()">

            <i class="fas fa-star" v-bind:class="{ gray: !isActiveStar1, 'orange': isActiveStar1 }"
                @click="selectRange(1)" @mouseenter="mouseSelectRange(1)"></i>
            <i class="fas fa-star" v-bind:class="{ gray: !isActiveStar2, 'orange': isActiveStar2 }"
                @click="selectRange(2)"  @mouseenter="mouseSelectRange(2)" ></i>
            <i class="fas fa-star" v-bind:class="{ gray: !isActiveStar3, 'orange': isActiveStar3 }"
                @click="selectRange(3)"  @mouseenter="mouseSelectRange(3)" ></i>
            <i class="fas fa-star" v-bind:class="{ gray: !isActiveStar4, 'orange': isActiveStar4 }"
                @click="selectRange(4)"  @mouseenter="mouseSelectRange(4)" ></i>
            <i class="fas fa-star" v-bind:class="{ gray: !isActiveStar5, 'orange': isActiveStar5 }"
                @click="selectRange(5)"  @mouseenter="mouseSelectRange(5)" ></i>
        </p>
    </form>
</template>

<script>
import './calification.css';
export default {
    props: {
        calification: {
            type: Number,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isActiveStar1: false,
            isActiveStar2: false,
            isActiveStar3: false,
            isActiveStar4: false,
            isActiveStar5: false,
            selectedValue: 0
        }
    },
    mounted() {
        this.drawStarts(this.calification);
        this.selectedValue = this.calification;
    },
    watch: {
        calification: function (newVal, oldVal) {
            this.drawStarts(newVal);
            this.selectedValue = newVal;
        }
    },
    methods: {
        selectRange(calification) {
            this.drawStarts(calification);
            this.selectedValue = calification;
            this.$emit('selectCalification', calification);
        },
        mouseSelectRange(calification){
            this.drawStarts(calification)
        },
        drawStarts(calification) {
            for (let i = 1; i <= 5; i++) {
                if (i <= calification) {
                    this['isActiveStar' + i] = true
                } else {
                    this['isActiveStar' + i] = false
                }
            }
        },
        resetStartsSelected() {
            this.drawStarts(this.selectedValue)
        }
    }
}
</script>
